import userSession from "../Constant/auth";
import { APP_SERVICES_URL } from "../Constant/constant";

// api.js
const createIncidentAPI = async (requestData) => {
  const { CustID, authHeader, site } = userSession;
  const url = `${APP_SERVICES_URL}/sn-incidents-service/${CustID}/incident`;

  const formattedData = {
    siteName: site.name,
    ...(requestData.eventID !== null && { eventID: requestData.eventID }),
    ...(requestData.incidentDate !== null && { detected: requestData.incidentDate }),
    ...(requestData.type !== null && { type: requestData.type }),
    ...(requestData.pumpNumber !== null && { pumpNumber: requestData.pumpNumber }),
    ...(requestData.licencePlateNumber !== null && { ocr: requestData.licencePlateNumber }),
    ...(requestData.colour !== null && { vehicleColor: requestData.colour }),
    ...(requestData.make !== null && { vehicleMake: requestData.make }),
    ...(requestData.shape !== null && { vehicleShape: requestData.shape }),
    ...(requestData.fuelType !== null && { fuelType: requestData.fuelType }),
    ...(requestData.fuelLitres !== null && { fuelLitres: requestData.fuelLitres }),
    ...(requestData.fuelCost !== null && { fuelValue: requestData.fuelCost }),
    ...(requestData.reference !== null && { fuelReference: requestData.reference }),
    ...(requestData.customerPhoneNumber !== null && { customerPhoneNumber: requestData.customerPhoneNumber }),
    ...(requestData.customerName !== null && { customerName: requestData.customerName }),
    ...(requestData.customerAddress !== null && { customerAddress: requestData.customerAddress }),
    customerGender: 'unknown',
    ...(requestData.employeeName !== null && { employeeName: requestData.employeeName }),
    ...(requestData.note !== null && { note: requestData.note }),
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': authHeader,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedData),
      redirect: 'follow', // Follow redirection
      mode: 'cors', // Enable CORS
    });
    if (response.status === 200) {
      const jsonData = await response.json();
      return { success: true, eventID: jsonData.eventID };
    } else {
      const errorText = await response.text();
      const isDuplicate = /Duplicate incident/i.test(errorText);

      return {
        success: false,
        message: getFailureReason(response.status, errorText),
        status: response.status,
        isDuplicate
      };
    }
  } catch (error) {
    // fetch only throws when the request never reached the server
    return {
      success: false,
      message: "Unable to reach the server. Please check the network connection.",
      status: null,
      isDuplicate: false
    };
  }
};

// Builds a user readable failure reason from the server response
const getFailureReason = (status, errorText) => {
  let serverMessage = "";
  try {
    serverMessage = JSON.parse(errorText).message || "";
  } catch (e) {
    serverMessage = "";
  }

  if (status === 401) {
    return "Your session has expired. Please log in again.";
  }
  if (status === 403) {
    return "You do not have access to create incidents for this site.";
  }
  if (status === 404) {
    // Missing site/event come back as 400, so a 404 means the incident service itself was not found
    return serverMessage || "The service is unavailable. Please try again later.";
  }
  if (status >= 500) {
    // Catch-all server errors only carry "Internal Server Error.", which is not useful to show
    if (!serverMessage || /internal server error/i.test(serverMessage)) {
      return "An unexpected server error occurred. Please try again later.";
    }
    return serverMessage;
  }
  if (!serverMessage) {
    return "The request could not be processed. Please try again later.";
  }
  return serverMessage;
};

export default createIncidentAPI;